import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Factory from '../entities/factory'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface FactoryState extends ListState<Factory>{
    editFactory:Factory
}
class UserMutations extends ListMutations<Factory>{

}
class FactoryModule extends ListModule<FactoryState,any,Factory>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Factory>(),
        loading:false,
        editFactory:new Factory()
    }
    actions={
        async getPaged(context:ActionContext<FactoryState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Factory/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Factory>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            ///console.log(page.items);
        },
        async create(context:ActionContext<FactoryState,any>,payload:any){
            await Ajax.post('/api/services/app/Factory/Create',payload.data);
        },
        async update(context:ActionContext<FactoryState,any>,payload:any){
            await Ajax.put('/api/services/app/Factory/Update',payload.data);
        },
        async delete(context:ActionContext<FactoryState,any>,payload:any){
            await Ajax.delete('/api/services/app/Factory/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<FactoryState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Factory/GetById?Id='+payload.id);
            return reponse.data.result as Factory;
        },
    };
    mutations={
        setCurrentPage(state:FactoryState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:FactoryState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:FactoryState,factory:Factory){
            
            state.editFactory=factory;
            //console.log(state.editFloor);
        }
    }
}
const factoryModule=new FactoryModule();
export default factoryModule;